/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
    Trash,
    EditIcon,
    AddIcon,
    TrashWhite
} from "../../assets/icons/icons";
import CustomAlert from "../CustomAlert";
import axios from 'axios';

export default function AddCategory() {
    const [showModal, setShowModal] = useState(false);
    const [editData, setEditData] = useState({});
    const [categories, setCategories] = useState([]);
    const [image, setImage] = useState(null);
    const [preview, setPreview] = useState(null);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [alert, setAlert] = useState({ show: false, type: '', message: '' });
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [showDeleteSelectedDialog, setShowDeleteSelectedDialog] = useState(false);
    const [categoryToDelete, setCategoryToDelete] = useState(null);

    const showCustomAlert = (type, message) => {
        setAlert({ show: true, type, message });
    };

    const closeAlert = () => {
        setAlert({ show: false, type: '', message: '' });
    };

    useEffect(() => {
        const token = sessionStorage.getItem("authToken");
        if (token) {
            axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        }
    }, []);

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            const response = await axios.get("https://laravel-api.aj-mart.com/api/categories");
            const data = response.data;

            if (data.category) {
                setCategories(data.category);
                setSelectedCategories([]);
            } else {
                showCustomAlert('error', 'Error fetching categories');
            }
        } catch (error) {
            showCustomAlert('error', 'Error fetching categories');
        }
    };

    const handleCategorySelect = (categoryId) => {
        setSelectedCategories(prev => {
            if (prev.includes(categoryId)) {
                return prev.filter(id => id !== categoryId);
            } else {
                return [...prev, categoryId];
            }
        });
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedCategories(categories.map(cat => cat.category_id));
        } else {
            setSelectedCategories([]);
        }
    };

    const handleBulkDelete = () => {
        if (selectedCategories.length === 0) {
            showCustomAlert('error', 'Please select categories to delete');
            return;
        }
        setShowDeleteSelectedDialog(true);
    };

    const confirmDeleteSelectedCategories = async () => {
        try {
            await Promise.all(selectedCategories.map(categoryId =>
                axios.delete(`https://laravel-api.aj-mart.com/api/categories/delete/${categoryId}`)
            ));
            setCategories(categories.filter(category => !selectedCategories.includes(category.category_id)));
            setSelectedCategories([]);
            showCustomAlert('success', 'Categories deleted successfully');
            setShowDeleteSelectedDialog(false);
        } catch (error) {
            showCustomAlert('error', 'An error occurred while deleting categories');
            setShowDeleteSelectedDialog(false);
        }
    };

    const handleEditClick = (data) => {
        setEditData(data);
        setShowModal(true);
        setPreview(data.category_img);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setEditData({});
        setPreview(null);
        setImage(null);
    };

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setImage(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData();
        const categoryNameE = event.target.categoryNameE.value;
        const categoryNameA = event.target.categoryNameA.value;

        // Only append fields if they have values
        if (categoryNameE) formData.append('category_name_E', categoryNameE);
        if (categoryNameA) formData.append('category_name_A', categoryNameA);
        if (image) formData.append('category_img', image);

        try {
            const response = await axios.post('https://laravel-api.aj-mart.com/api/categories/add', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            const data = response.data;

            if (data.success && data.category) {
                // Add the new category to the beginning of the categories array
                setCategories([data.category, ...categories]);
                showCustomAlert('success', 'Category added successfully');
                event.target.reset();
                setPreview(null);
                setImage(null);
            } else {
                let errorMessage = 'Error adding category.';
                if (data.errors) {
                    errorMessage += '\n' + Object.values(data.errors).flat().join('\n');
                } else if (data.message) {
                    errorMessage = data.message;
                }
                showCustomAlert('error', errorMessage);
            }
        } catch (error) {
            showCustomAlert('error', 'An unexpected error occurred.');
        }
    };

    const handleUpdate = async () => {
        const formData = new FormData();
        // Only append fields if they have values
        if (editData.category_name_E) formData.append('category_name_E', editData.category_name_E);
        if (editData.category_name_A) formData.append('category_name_A', editData.category_name_A);
        if (image) formData.append('category_img', image);

        try {
            const response = await axios.post(`https://laravel-api.aj-mart.com/api/categories/update/${editData.category_id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'X-HTTP-Method-Override': 'PUT'
                },
            });
            const data = response.data;

            if (data.message === 'Category updated successfully' || data.success) {
                showCustomAlert('success', 'Category updated successfully');
                fetchCategories();
                handleCloseModal();
                setPreview(null);
                setImage(null);
            } else {
                let errorMessage = 'Error updating category';
                if (data.errors) {
                    errorMessage += '\n' + Object.values(data.errors).flat().join('\n');
                } else if (data.message) {
                    errorMessage = data.message;
                }
                showCustomAlert('error', errorMessage);
            }
        } catch (error) {
            showCustomAlert('error', 'An unexpected error occurred.');
        }
    };

    const handleDelete = (categoryId) => {
        setCategoryToDelete(categoryId);
        setShowDeleteDialog(true);
    };

    const confirmDelete = async () => {
        try {
            await axios.delete(`https://laravel-api.aj-mart.com/api/categories/delete/${categoryToDelete}`);
            showCustomAlert('success', 'Category deleted successfully');
            fetchCategories();
            setShowDeleteDialog(false);
            setCategoryToDelete(null);
        } catch (error) {
            showCustomAlert('error', 'An unexpected error occurred.');
            setShowDeleteDialog(false);
            setCategoryToDelete(null);
        }
    };

    return (
        <section className="py-[25px] flex flex-col gap-[15px]">
            {alert.show && (
                <CustomAlert
                    type={alert.type}
                    message={alert.message}
                    onClose={closeAlert}
                />
            )}
            <div className="main-title mb-[20px]">Add Category</div>
            <div>
                <form onSubmit={handleSubmit}>
                    <div className="flex flex-col gap-[10px]">
                        <div className="flex flex-col gap-[5px] w-[49%]">
                            <label className="text-black">Category Name In English</label>
                            <input
                                type="text"
                                name="categoryNameE"
                                className="px-[15px] py-[7px] outline-none border-2 border-[#1485a6] rounded-[4px] text-black bg-[#eeeeee6e]"
                                placeholder="Category Name In English"
                            />
                        </div>
                        <div className="flex flex-col gap-[5px] w-[49%]">
                            <label className="text-black">Category Name In Arabic</label>
                            <input
                                type="text"
                                name="categoryNameA"
                                className="px-[15px] py-[7px] outline-none border-2 border-[#1485a6] rounded-[4px] text-black bg-[#eeeeee6e]"
                                placeholder="Category Name In Arabic"
                            />
                        </div>
                        <div className="flex flex-col gap-[5px] w-[49%]">
                            <label className="text-black">Category picture :</label>
                            <div className="flex items-center gap-[10px]">
                                <label
                                    htmlFor="upload-image"
                                    className="cursor-pointer border-2 border-[#1485a6] bg-[#eeeeee6e] text-black px-[15px] py-[7px] rounded-[4px] flex items-center justify-center"
                                >
                                    {preview ? (
                                        <img
                                            src={preview}
                                            alt="Preview"
                                            className="w-[40px] h-[40px] object-contain rounded"
                                        />
                                    ) : (
                                        "Upload Image"
                                    )}
                                </label>
                                <input
                                    id="upload-image"
                                    type="file"
                                    accept="image/*"
                                    className="hidden"
                                    onChange={handleImageChange}
                                />
                            </div>
                        </div>
                        <button type="submit" className="btn flex items-center gap-[5px]">
                            <AddIcon />
                            <span>Add a Category</span>
                        </button>
                    </div>
                </form>
            </div>
            <div className="flex justify-end items-center gap-[10px] capitalize mb-[20px]">
                <button
                    className={`btn bg-red-500 hover:bg-red-600 flex items-center gap-2 ${selectedCategories.length === 0 ? 'opacity-50 cursor-not-allowed' : ''}`}
                    onClick={handleBulkDelete}
                    disabled={selectedCategories.length === 0}
                >
                    <TrashWhite />
                    <span>Delete Selected ({selectedCategories.length})</span>
                </button>
            </div>
            <div className="overflow-x-auto">
                <table className="w-full border-collapse border border-gray-200 text-left">
                    <thead className="bg-gray-100">
                        <tr>
                            <th className="border border-gray-200 p-[10px] capitalize">
                                <input
                                    type="checkbox"
                                    onChange={handleSelectAll}
                                    checked={selectedCategories.length === categories.length && categories.length > 0}
                                />
                            </th>
                            <th className="border border-gray-200 p-[10px] capitalize">IMG</th>
                            <th className="border border-gray-200 p-[10px] capitalize">Category Name In English</th>
                            <th className="border border-gray-200 p-[10px] capitalize">Category Name In Arabic</th>
                            <th className="border border-gray-200 p-[10px] capitalize">Control tools</th>
                        </tr>
                    </thead>
                    <tbody>
                        {categories.map((category) => (
                            <tr key={category.category_id} className="bg-white hover:bg-gray-50">
                                <td className="border border-gray-200 p-[10px]">
                                    <input
                                        type="checkbox"
                                        className="w-[18px] h-[18px]"
                                        checked={selectedCategories.includes(category.category_id)}
                                        onChange={() => handleCategorySelect(category.category_id)}
                                    />
                                </td>
                                <td className="border border-gray-200 p-[10px]">
                                    <img
                                        src={`https://laravel-api.aj-mart.com/storage/app/public/${category.category_img}`}
                                        alt=""
                                        className="w-[40px] h-[40px] object-contain"
                                    />
                                </td>
                                <td className="border border-gray-200 p-[10px]">{category.category_name_E}</td>
                                <td className="border border-gray-200 p-[10px]">{category.category_name_A}</td>
                                <td className="border border-gray-200 p-[10px]">
                                    <div className="flex items-center gap-3">
                                        <button
                                            className="cursor-pointer"
                                            onClick={() => handleEditClick(category)}
                                        >
                                            <EditIcon className="w-5 h-5 text-blue-600 hover:text-blue-700" />
                                        </button>
                                        <button
                                            className="cursor-pointer"
                                            onClick={() => handleDelete(category.category_id)}
                                        >
                                            <Trash className="w-5 h-5 text-red-600 hover:text-red-700" />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Edit Modal */}
            {showModal && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white w-[500px] rounded-lg shadow-lg p-[20px] relative">
                        <h2 className="text-xl font-bold mb-[10px]">Edit Category</h2>
                        <div className="flex flex-col gap-[10px] capitalize">
                            <div className="flex items-center justify-between">
                                <div>
                                    <label className="text-sm font-medium">IMG</label>
                                    <img
                                        src={`https://laravel-api.aj-mart.com/storage/app/public/${editData.category_img}`}
                                        alt=""
                                        className="w-[40px] h-[40px] object-contain"
                                    />
                                </div>
                                <div className="flex items-center gap-[10px]">
                                    <label
                                        htmlFor="edit-image"
                                        className="cursor-pointer border-2 border-[#1485a6] bg-[#eeeeee6e] text-black px-[15px] py-[7px] rounded-[4px] flex items-center justify-center"
                                    >
                                        {preview ? (
                                            <img
                                                src={preview}
                                                alt="Preview"
                                                className="w-[40px] h-[40px] object-contain rounded"
                                            />
                                        ) : (
                                            "Edit Image"
                                        )}
                                    </label>
                                    <input
                                        id="edit-image"
                                        type="file"
                                        accept="image/*"
                                        className="hidden"
                                        onChange={handleImageChange}
                                    />
                                </div>
                            </div>
                            <label className="text-sm font-medium">
                                Category Name In English
                                <input
                                    type="text"
                                    className="block w-full mt-1 p-[10px] capitalize border rounded"
                                    value={editData.category_name_E || ''}
                                    onChange={(e) =>
                                        setEditData({
                                            ...editData,
                                            category_name_E: e.target.value,
                                        })
                                    }
                                />
                            </label>
                            <label className="text-sm font-medium">
                                Category Name In Arabic
                                <input
                                    type="text"
                                    className="block w-full mt-1 p-[10px] capitalize border rounded"
                                    value={editData.category_name_A || ''}
                                    onChange={(e) =>
                                        setEditData({
                                            ...editData,
                                            category_name_A: e.target.value,
                                        })
                                    }
                                />
                            </label>
                        </div>
                        <div className="flex justify-end gap-3 mt-[20px]">
                            <button
                                className="btn bg-gray-300 hover:bg-gray-400"
                                onClick={handleCloseModal}
                            >
                                Cancel
                            </button>
                            <button
                                className="btn bg-green-500 hover:bg-green-600 text-white"
                                onClick={handleUpdate}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Single Delete Confirmation Dialog */}
            {showDeleteDialog && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white w-[400px] rounded-lg shadow-lg p-[20px] relative">
                        <h2 className="text-xl font-bold mb-[10px]">Confirm Deletion</h2>
                        <p className="text-sm mb-[20px]">
                            Are you sure you want to delete this category?
                        </p>
                        <div className="flex justify-end gap-3">
                            <button
                                className="btn bg-gray-300 hover:bg-gray-400"
                                onClick={() => {
                                    setShowDeleteDialog(false);
                                    setCategoryToDelete(null);
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                className="btn bg-red-500 hover:bg-red-600 text-white"
                                onClick={confirmDelete}
                            >
                                Confirm Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Bulk Delete Confirmation Dialog */}
            {showDeleteSelectedDialog && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white w-[400px] rounded-lg shadow-lg p-[20px] relative">
                        <h2 className="text-xl font-bold mb-[10px]">Confirm Deletion</h2>
                        <p className="text-sm mb-[20px]">
                            Are you sure you want to delete the selected categories?
                        </p>
                        <div className="flex justify-end gap-3">
                            <button
                                className="btn bg-gray-300 hover:bg-gray-400"
                                onClick={() => setShowDeleteSelectedDialog(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className="btn bg-red-500 hover:bg-red-600 text-white"
                                onClick={confirmDeleteSelectedCategories}
                            >
                                Confirm Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
}